<script setup lang="ts">
defineProps({
  loading: { type: Boolean },
  outlined: { type: Boolean },
  blue: { type: Boolean },
  emphasis: { type: Boolean }
})
const active = ref(false)
const select = ref<HTMLDivElement>()

function handleClickOutside(event: MouseEvent) {
  if (!event.target)
    return
  if (event.target === select.value || select.value?.contains(event.target as any))
    return
  if (active.value)
    toggle()
}

function toggle() {
  if (active.value) {
    active.value = false
    document.body.removeEventListener("click", handleClickOutside)
  }
  else {
    active.value = true
    document.body.addEventListener("click", handleClickOutside)
  }
}
</script>

<template>
  <div class="relative">
    <div ref="select" class="relative inline-block text-left">
      <div
        class="inline-select-button t-menu-sm"
        :class="{ blue, outlined, emphasis }"
        @click="toggle()"
      >
        <div>
          <slot />
        </div>
        <interface-spinner
          v-if="loading"
          class="action spinner"
        />
        <icon-action
          v-else
          size="2xs"
          type="chevron-down"
          class="action dropdown-arrow"
          :class="{ blue, emphasis }"
        />
      </div>
    </div>
    <div
      v-show="active"
      class="menu-dropdown-container absolute -right-2 bottom-[100%] mb-2 inline-select-dropdown"
    >
      <slot name="content" />
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'
.inline-select-button
  @apply hover:bg-[#{$menu-bg-item-hover}]
  @apply flex cursor-pointer items-center gap-1 rounded-[#{$menu-br-item}] p-1 px-1.5 -m-1 -mx-1.5 h-6 t-menu-sm
  &:not(.blue)
    @apply text-$global-t-secondary
  &.blue:not(.emphasis)
    @apply bg-$global-blue-accent outline-$global-blue-secondary text-$global-blue-primary
  &.blue.emphasis
    @apply bg-$global-blue-primary text-[#{$global-t-default}]
  &.outlined:not(.emphasis)
    @apply outline rounded-[#{$menu-br-item}] outline-0.5
  .action
    &.dropdown-arrow
      @apply -mr-1
    &.spinner
      @apply h-2 w-2
    &.blue:not(.emphasis)
      @apply text-$global-blue-primary
    &.blue.emphasis
      @apply text-[#{$global-t-default}]

.inline-select-dropdown
  @apply
</style>
